/**
 * Which rounds the bet-history sheet should ask the server to settle for this
 * player right now (D-49).
 *
 * Why the sheet has to ask at all: the result of a round is public within ~40 s
 * of the round ending, but the background settler that pays bets out has been
 * measured 58–293 s behind that (p50 110 s over 175 rounds, 2026-09-13). Inside a
 * room the page hides this by calling `settle-my` the moment the draw lands, so
 * the settlement card shows up 6–10 s after the result. Opened from Perfil the
 * sheet had no such trigger, and a bet sat on PENDENTE for two minutes after
 * everyone could already see the number — polling every 5 s faithfully
 * re-reading "still pending" from a server that had not paid it yet.
 *
 * A round qualifies when the sheet holds a still-pending bet in it AND the API
 * already shipped that round's draw (`draw` is only non-empty once the result is
 * public, so `settle-my` cannot be called early). Milhar is excluded: it has its
 * own settler and `settle-my` does not touch it. `attempted` keeps this to one
 * request per round per sheet — the poll picks up whatever a request could not
 * settle. Capped at 3 per pass, like the room page.
 */
export type SettleCandidate = {
  round: number;
  game: string;
  result: 'pending' | 'win' | 'lose' | 'cancelled';
  draw?: object;
};

export function roundsAwaitingSettlement(
  bets: SettleCandidate[],
  attempted: ReadonlySet<number>,
  cap = 3,
): number[] {
  const rounds: number[] = [];
  for (const bet of bets) {
    if (bet.result !== 'pending') continue;
    if (bet.game === 'milhar') continue;
    if (!bet.draw || Object.keys(bet.draw).length === 0) continue;
    if (!(bet.round > 0) || attempted.has(bet.round) || rounds.includes(bet.round)) continue;
    rounds.push(bet.round);
    if (rounds.length >= cap) break;
  }
  return rounds;
}
